/* Related products: loads Shopify's product recommendations into the grid when the section scrolls near
   (Section Rendering API through the recommendations URL). Hides the section if there are none. */
if (!customElements.get('lmb-related')) {
  customElements.define(
    'lmb-related',
    class LmbRelated extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) {
          this.load();
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async load() {
        const section = this.closest('.rp');
        try {
          const doc = await LMB.fetchHTML(this.dataset.url);
          const grid = doc.querySelector('[data-related-grid]');
          if (!grid || !grid.children.length) throw new Error('No recommendations');
          this.replaceChildren(grid);
        } catch (error) {
          if (section) section.hidden = true;
        }
      }
    }
  );
}
